var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArraowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3779 8.27208C22.3779 7.91309 22.0869 7.62208 21.7279 7.62208L15.8779 7.62208C15.5189 7.62208 15.2279 7.91309 15.2279 8.27208C15.2279 8.63106 15.5189 8.92208 15.8779 8.92208L21.0779 8.92208L21.0779 14.1221C21.0779 14.4811 21.3689 14.7721 21.7279 14.7721C22.0869 14.7721 22.3779 14.4811 22.3779 14.1221L22.3779 8.27208ZM9.45962 21.4596L22.1875 8.7317L21.2683 7.81246L8.54038 20.5404L9.45962 21.4596Z",
    fill: "#282828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArraowButton);
export default __webpack_public_path__ + "static/media/arraowButton.333810d1633fd9f1a78f0c9ef38309da.svg";
export { ForwardRef as ReactComponent };